import { useContext } from 'react';

import { app } from 'context';
import { IconButton } from 'ds';
import { Layout, PillButton } from 'ds';

interface MobileSaveAndResetChangesProps {
  onSave: () => void;
  onReset: () => void;
}

const MobileSaveAndResetChanges = ({ onSave, onReset }: MobileSaveAndResetChangesProps) => {
  const { bottomNavigationHeight } = useContext(app);
  return (
    <Layout
      width="100%"
      position="sticky"
      bottom={bottomNavigationHeight}
      left={0}
      right={0}
      height={64}
      paddingX={24}
      direction="row"
      gap={8}
    >
      <Layout flexGrow={1} justify="center">
        <PillButton fullWidth size="lg" type="primary" text="Save changes" onClick={onSave} />
      </Layout>
      <IconButton size="lg" type="white" name="refresh" onClick={onReset} />
    </Layout>
  );
};

export default MobileSaveAndResetChanges;
